import { render, staticRenderFns } from "./AulaResizableContainter.vue?vue&type=template&id=20e68ca6&scoped=true&"
import script from "./AulaResizableContainter.vue?vue&type=script&lang=js&"
export * from "./AulaResizableContainter.vue?vue&type=script&lang=js&"
import style0 from "./AulaResizableContainter.vue?vue&type=style&index=0&id=20e68ca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e68ca6",
  null
  
)

export default component.exports